/* eslint-disable */
//tslint:disable

export interface IInfrastructureTypeSchema {
  /** Количество геообъектов **/
  count: number;
  /** Описание **/
  description?: string | null;
  /** Тип отрисовки **/
  drawType: EDrawType;
  /** Иконка **/
  icon: EIcon;
  /** Цвет пина **/
  iconColor?: EIconColor | null;
  /** ID **/
  id: number;
  /** Название **/
  name: string;
  /** Цвет пина **/
  pinColor?: EPinColor | null;
}

export enum EDrawType {
  /**  **/
  Heatmap = 'heatmap',
  /**  **/
  Pin = 'pin',
}
export enum EIcon {
  /** Иконка поликлиники **/
  Clinic = 'clinic',
  /** Без иконки **/
  Empty = 'empty',
  /** Иконка магазина **/
  Grocery = 'grocery',
  /** Иконка детского сада **/
  Nursery = 'nursery',
  /** Иконка школы **/
  School = 'school',
}

export enum EIconColor {
  /** Тёмный **/
  Black = '#152242',
  /** Белый **/
  White = '#FFFFFF',
}

export enum EPinColor {
  /** Серый **/
  Gray = '#35415E',
  /** Пурпурный **/
  Purple = '#8729FF',
  /** Красный **/
  Red = '#DB1F36',
  /** Оранжевый **/
  Orange = '#FDC221',
}
